import React from 'react';
import './RangeSlider.css';

const RangeSlider = ({ 
  label, 
  min, 
  max, 
  value, 
  onChange, 
  unit = '', 
  step = 1 
}) => {
  return (
    <div className="range-slider-container">
      <label className="range-slider-label">
        {label}
        <span className="range-value">
          {value[0]} - {value[1]} {unit}
        </span>
      </label>
      <div className="range-slider-wrapper">
        <input
          type="range"
          min={min}
          max={max}
          value={value[0]}
          step={step}
          onChange={(e) => onChange([parseInt(e.target.value), value[1]])}
          className="range-input range-input-min"
        />
        <input
          type="range"
          min={min}
          max={max}
          value={value[1]}
          step={step}
          onChange={(e) => onChange([value[0], parseInt(e.target.value)])}
          className="range-input range-input-max"
        />
        <div className="range-track">
          <div 
            className="range-track-highlight"
            style={{
              left: `${((value[0] - min) / (max - min)) * 100}%`,
              right: `${100 - ((value[1] - min) / (max - min)) * 100}%`
            }}
          />
        </div>
      </div>
      <div className="range-labels">
        <span>{min} {unit}</span>
        <span>{max} {unit}</span>
      </div>
    </div>
  );
};

export default RangeSlider;
